import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2dff54d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tir-pm-icon-picker-view-icon" }

import { TirPmSvg } from "tir-pm-svg";
import { IconColorType, IconType } from "./types";


export default /*#__PURE__*/_defineComponent({
  __name: 'TirPmIconPickerViewIcon',
  props: {
    icon: {},
    color: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(TirPmSvg), {
      class: "tir-pm-icon-picker-view-icon__icon",
      url: _ctx.icon.IconUrl,
      style: _normalizeStyle({
        color: _ctx.color?.Color,
      })
    }, null, 8, ["url", "style"]),
    _createElementVNode("div", {
      class: "tir-pm-icon-picker-view-icon__bg",
      style: _normalizeStyle({
        backgroundColor: _ctx.color?.Color,
        opacity: _ctx.color?.Color ? '0.1 ' : '1',
      })
    }, null, 4)
  ]))
}
}

})